import { render, staticRenderFns } from "./totop.vue?vue&type=template&id=a06165fa&scoped=true"
import script from "./totop.vue?vue&type=script&lang=js"
export * from "./totop.vue?vue&type=script&lang=js"
import style0 from "./totop.vue?vue&type=style&index=0&id=a06165fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06165fa",
  null
  
)

export default component.exports